<template>
    <div>
        <div class="flex flex-wrap">
            <label class="w-full"> Unidade Comercial </label>
            <v-select v-model="comercialUnit" :options="unitiesData" :clearable="false" class="mb-6 md:w-4/12 lg:w-4/12 xl:w-4/12" />
        </div>

        <div class="flex flex-wrap">
            <label class="w-full"> Unidade Tributável </label>
            <v-select v-model="taxUnit" :options="unitiesData" :clearable="false" class="mb-6 md:w-4/12 lg:w-4/12 xl:w-4/12" />
        </div>

        <div class="flex flex-wrap">
            <label class="w-full"> CFOP </label>
            <vs-input v-model="CFOP" class="mb-6 sm:w-full md:w-4/12 lg:w-4/12 xl:w-4/12" />
        </div>

        <div class="flex flex-wrap">
            <label class="w-full"> CSOSN </label>
            <vs-input v-model="CSOSN" class="mb-6 sm:w-full md:w-4/12 lg:w-4/12 xl:w-4/12" />
        </div>

        <div class="flex flex-wrap">
            <label class="w-full"> NCM </label>
            <vs-input v-model="NCM" class="mb-6 sm:w-full md:w-4/12 lg:w-4/12 xl:w-4/12" />
        </div>

        <div class="flex flex-wrap">
            <label class="w-full"> cEAN </label>
            <vs-input v-model="cEAN" class="mb-6 sm:w-full md:w-4/12 lg:w-4/12 xl:w-4/12" />
        </div>
    </div>
</template>

<script>
    import { unities } from './unities'
    import { mapState, mapMutations } from 'vuex'
    import vSelect from 'vue-select'

    export default {
        components : {
            vSelect
        },

        data () {
            return {
                unitiesData : [...unities]
            }
        },

        computed : {
            comercialUnit : {
                get () {
                    const selected = this.productInfo.fiscal && this.productInfo.fiscal.unidadeComercial
                    return this.unitiesData.find(u => u.id == selected)
                     
                },
                set (val) {
                    this.setComercialUnit(val.id)
                }
            },
            taxUnit : {
                get () {
                    const selected = this.productInfo.fiscal && this.productInfo.fiscal.unidadeTributavel
                    return this.unitiesData.find(u => u.id == selected)
                     
                },
                set (val) {
                    this.setTaxUnit(val.id)
                }
            },
            CFOP : {
                get () {
                    return this.productInfo.fiscal && this.productInfo.fiscal.CFOP
                },
                set (val) {
                    this.setCFOP(val)
                }
            },
            CSOSN : {
                get () {
                    return this.productInfo.fiscal && this.productInfo.fiscal.CSOSN
                },
                set (val) {
                    this.setCSOSN(val)
                }
            },
            NCM : {
                get () {
                    return this.productInfo.fiscal && this.productInfo.fiscal.NCM
                },
                set (val) {
                    this.setNCM(val)
                }
            },
            cEAN : {
                get () {
                    return this.productInfo.fiscal && this.productInfo.fiscal.cEAN
                },
                set (val) {
                    this.setCEAN(val)
                }
            },
            ...mapState('product', ['productInfo'])
        },

        methods : {
            ...mapMutations('product', ['setComercialUnit', 'setTaxUnit', 'setCFOP', 'setCSOSN', 'setNCM', 'setCEAN'])
        }
    }
</script>
